import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=6a1f443c&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"
import style0 from "./RequestItem.vue?vue&type=style&index=0&id=6a1f443c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f443c",
  null
  
)

export default component.exports